module.exports = __webpack_public_path__ + "static/img/qianru.59fc324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qianru.png
// module id = whKF
// module chunks = 0